import type { PendingAction } from "../../api";

export type ProjectSyncStatus = "failed" | "review" | "healthy";

/** Returns the highest-priority pending sync state for one project. */
export function projectSyncStatus(projectId: string, actions: readonly PendingAction[]): ProjectSyncStatus {
  if (actions.some((action: PendingAction) => action.project_id === projectId && action.type === "sync_failed")) {
    return "failed";
  }
  if (actions.some((action: PendingAction) => action.project_id === projectId && action.type === "sync_review")) {
    return "review";
  }
  return "healthy";
}
